import Drawer from "@mui/material/Drawer";

const TableDrawer = ({
  open,
  children,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => (
  <Drawer
    open={open}
    className="min-w-[200px]"
    onClose={onClose}
    anchor="right"
    transitionDuration={0}
    slotProps={{
      backdrop: {
        sx: {
          backdropFilter: "blur(3px)",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
        },
      },
    }}
  >
    <div className="min-w-[1000px] max-w-[1000px] h-full bg-slate-100">
      {children}
    </div>
  </Drawer>
);

export default TableDrawer;
